import { AuthProvider } from './apis/Auth';
import './App.css';
import { MainLayout } from './view/common/MainLayout';

export const App = () => {

    return (
        <AuthProvider>
            <MainLayout/>
        </AuthProvider>
    );
    
}; 
